import React, { useState } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import styled from "styled-components"
import "../components/styles/klaus-gridski.css"
import GlobalStyles from "../components/styles/globalStyles"

import { Wrapper } from "./styles/container"

import Logo from "../images/logo_rot.png"
import LogoFooter from "../images/logo_footer.png"
const HeaderStyle = styled.header`
  padding: 3rem 0;
`

const LogoStyle = styled.img`
  width: 170px;
  height: auto;
  z-index: 16;
  position: relative;
`

const FooterLogo = styled.img`
  max-width: 150px;
  margin-bottom: 1rem;
`

const Navigation = styled.nav`
  background: var(--background);
  font-size: 1.8rem;
  margin-top: 2rem;
  ul {
    list-style: none;
    padding: 0;
    li {
      margin-right: 3rem;
      padding: 1rem;
      :hover {
        background-color: var(--red);
        color: white;
      }
    }
  }
`

const MobileMenu = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: white;
  padding: 12rem 4rem 0 2rem;
  z-index: 15;
  ul {
    list-style: none;
    font-weight: 600;
    li {
      padding: 0.7rem;

      font-size: 1.5rem;
    }
  }
`

const MobieSubmenu = styled.ul`
  transform: translateX(5px);
  color: var(--footer);
`

const FooterStyle = styled.footer`
  background-color: var(--footer);
  color: var(--background);
  padding: 4rem 0;
  font-size: 1.5rem;
  strong {
    font-size: 1.8rem;
  }
`

const FooterContent = styled.div`
  div {
    padding: 0 3rem 0 0;
    margin-top: 3rem;

    /* ==== = LARGE = ==== */
    @media only screen and (min-width: 75em) {
      margin-top: 0;
    }
  }
`

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  // -----------------------------initialize state for mobile menu
  const [showMenu, setshowMenu] = useState(false)

  // ----------------------------function to change the state
  const menuActive = () => {
    setshowMenu(!showMenu)
    const body = document.querySelector("body")
    body.classList.toggle("no-scrolling")
  }

  return (
    <div className="body-grid">
      <GlobalStyles />
      <HeaderStyle siteTitle={data.site.siteMetadata?.title || `Title`}>
        <Wrapper className="flex vertical">
          <div className="flex between v-center">
            <h1 className="disappear l-appear">Webcams in Friedberg</h1>
            <Link to="/">
              <LogoStyle alt="Safetec Logo" src={Logo} />
            </Link>
            <div className="l-disappear">
              <button
                onClick={menuActive}
                className={` hamburger hamburger--slider ${
                  showMenu ? "is-active" : null
                } `}
                type="button"
                aria-label="Menü öffnen"
              >
                <span className="hamburger-box">
                  <span className="hamburger-inner"></span>
                </span>
              </button>
            </div>
          </div>
          {showMenu && (
            <MobileMenu className="l-disappear" onClick={menuActive}>
              <ul className="flex vertical ">
                <li>
                  <Link to="/" activeClassName="active">
                    Startseite
                  </Link>
                </li>
                <li>
                  <Link to="/webcams-friedberg" activeClassName="active">
                    Webcams in Friedberg
                  </Link>

                  <MobieSubmenu>
                    <li>
                      {" "}
                      <Link to="/kaiserstr-nord" activeClassName="active">
                        Kaiserstraße Nord
                      </Link>{" "}
                    </li>
                    <li>
                      {" "}
                      <Link to="/kaiserstr-mitte" activeClassName="active">
                        Kaiserstraße Mitte
                      </Link>{" "}
                    </li>
                    <li>
                      {" "}
                      <Link to="/altes-hallenbad" activeClassName="active">
                        Altes Hallenbad
                      </Link>{" "}
                    </li>
                  </MobieSubmenu>
                </li>
                <li>
                  {" "}
                  <Link to="/externe-webcams" activeClassName="active">
                    Externe Webcams
                  </Link>
                  <MobieSubmenu>
                    <li>
                      {" "}
                      <Link to="/bad-nauheim" activeClassName="active">
                        Bad Nauheim Bhf. West
                      </Link>{" "}
                    </li>
                  </MobieSubmenu>
                </li>
                <li>
                  {" "}
                  <Link to="/technik" activeClassName="active">
                    Technik
                  </Link>{" "}
                </li>
                <li>
                  {" "}
                  <Link to="/impressum" activeClassName="active">
                    Impressum
                  </Link>
                </li>
                <li>
                  {" "}
                  <Link to="/datenschutz" activeClassName="active">
                    Datenschutzerklärung
                  </Link>{" "}
                </li>
              </ul>
            </MobileMenu>
          )}
          <Navigation className="navigation disappear l-appear">
            <ul className="flex v-center">
              <li>
                <Link to="/" activeClassName="active">
                  Startseite
                </Link>
              </li>
              <li>
                <Link to="/webcams-friedberg" activeClassName="active">
                  Webcams in Friedberg
                </Link>

                <ul className="sub-menu">
                  <li>
                    {" "}
                    <Link to="/kaiserstr-nord" activeClassName="active">
                      Kaiserstraße Nord
                    </Link>{" "}
                  </li>
                  <li>
                    {" "}
                    <Link to="/kaiserstr-mitte" activeClassName="active">
                      Kaiserstraße Mitte
                    </Link>{" "}
                  </li>
                  <li>
                    {" "}
                    <Link to="/altes-hallenbad" activeClassName="active">
                      Altes Hallenbad
                    </Link>{" "}
                  </li>
                </ul>
              </li>
              <li>
                {" "}
                <Link to="/externe-webcams" activeClassName="active">
                  Externe Webcams
                </Link>
                <ul className="sub-menu">
                  <li>
                    {" "}
                    <Link to="/bad-nauheim" activeClassName="active">
                      Bad Nauheim Bhf. West
                    </Link>{" "}
                  </li>
                </ul>
              </li>
              <li>
                {" "}
                <Link to="/technik" activeClassName="active">
                  Technik
                </Link>{" "}
              </li>
              <li>
                {" "}
                <Link to="/impressum" activeClassName="active">
                  Impressum
                </Link>
              </li>
              <li>
                {" "}
                <Link to="/datenschutz" activeClassName="active">
                  Datenschutzerklärung
                </Link>{" "}
              </li>
            </ul>
          </Navigation>
        </Wrapper>
      </HeaderStyle>
      <main>{children}</main>
      <FooterStyle>
        <Wrapper className="flex vertical">
          <FooterContent className="flex vertical md-grid-appear md-col-2 l-col-4">
            <div>
              <FooterLogo alt="Safetec Logo" src={LogoFooter} />
              <p>
                Die Webcams in Friedberg (Hessen) sind ein Service der SAFETEC
                Timo Durchdewald Sicherungstechnik
              </p>
            </div>
            <div>
              <strong>Adresse</strong>
              <p>
                SAFETEC <br /> Timo Durchdewald Sicherungstechnik <br />
                Straßheimer Straße 19 <br /> 61169 Friedberg
              </p>
            </div>
            <div>
              <strong>Kontakt</strong> <br />
              <a title="Safetec anrufen" href="tel:0603172240">
                Tel: 06031 72240
              </a>
              <p>Fax: 06031 722422</p>
              <a title="Mail schreiben" href="mailto:s@fetec.biz">
                s@fetec.biz
              </a>
            </div>
            <div>
              <strong>Info</strong>
              <p>
                Weitere Informationen zu SAFETEC, Sicherungstechnik oder
                Videotechnik finden Sie hier:{" "}
                <a
                  target="_bank"
                  rel="noopener noreferrer"
                  href="https://safetec.biz/"
                >
                  www.safetec.biz
                </a>
              </p>
            </div>
          </FooterContent>
        </Wrapper>
      </FooterStyle>
    </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
